// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateAvailable-module__wrapper","icon":"UpdateAvailable-module__icon"};